// «رسائل المراجعين / الزبائن» — a row of the المواعيد module menu
// (HANDOFF-erp-web §3 row 4 → business app §5.14 «Customer messages
// (manager+)»). Manager+; online only (reminders go out over WhatsApp/push
// from the cloud — a node has no reminders surface). Module flag erp.core.
//
// Menu label: HANDOFF §3 writes «رسائل المراجعين» (clinic profile). A menu row
// can only carry a fixed label or a TermKey, and locales.json has no genitive
// customers token, so the row uses the handoff label until the lib grows one
// (SHARED-REQUESTS.md); the screen title follows the business's profile.
//
// Integrator: spread `messagesRoutes` into the booking module's `routes`,
// `messagesMenu` into its `menu`, and `./mock/handlers` `handlers` into
// src/features/booking/mock/handlers.ts.

import type { RouteObject } from 'react-router-dom';
import { gate, type Gate, type MenuItem } from '@/app/module-types';

export const MESSAGES_PATH = '/messages';

const messagesGate: Gate = { flag: 'erp.core', minRole: 'manager', modes: ['online'] };

export const messagesRoutes: RouteObject[] = [
  {
    path: MESSAGES_PATH,
    lazy: () => import('./screens/Messages').then((m) => ({ Component: m.MessagesRoute })),
    handle: gate(messagesGate),
  },
];

export const messagesMenu: MenuItem[] = [{ key: 'messages', label: 'رسائل المراجعين', to: MESSAGES_PATH, ...messagesGate }];
